export default class Text {
	constructor(r) {
		this.item = {};
		if(r != false) {
			this.item = r;
		}

		this.defaults();
	}

	isset(key) {
		if(typeof this.item[key] === 'undefined') {
			return false;
		}

		return true;
	}

	output() {
		return this.item;
	}

	defaults() {
		if(!this.isset('value')) {
			this.item.value = 'This is an example text.';
		}
		
		if(!this.isset('id')) {
			this.item.id = false;
		}

		if(!this.isset('padding')) {
			this.item.padding = '10px 10px 10px 10px';
		}
	}
}


// WEBPACK FOOTER //
// ./helpers/text.js